// EmptyDrawer.js
import React, { useContext, useState } from 'react';
import { Drawer, Typography, Grid, Stack, IconButton, Button, TextField, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import dayjs from 'dayjs';
import { DesktopDateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import Searchlist from '../../../../components/Common/Searchlist';
import { LanguageContext } from '../../../../libs/Context';

const SetReminderSlider = ({ open, onClose }) =>
{
	const [ selectedValue, setSelectedValue ] = useState('');
	const { language } = useContext(LanguageContext);
	const labels = [
		{ value: 'remindMe', label: language?.remindMe },
		{ value: 'remindOthers', label: language?.remindOthers }
	];

	const [ filter, setFilter ] = useState({
		startDate : dayjs().subtract(7, 'day'),
		endDate   : dayjs()
	});
	// Handler for date changes
	const handleCustomDateChange = (date, field) =>
	{
		setFilter((prevFilter) => ({
			...prevFilter,
			[field] : date
		}));
	};

	const handleChange = (event) =>
	{
		setSelectedValue(event.target.value);
	};

	return (
		<Drawer anchor='right' open={open} onClose={onClose} PaperProps={{
			sx : {
				width : {
					xs : '100%',
					sm : '70%',
					md : '30%',
					lg : '30%'
				}
			}
		}}
		>
			<Grid container height={'100%'} flexDirection={'column'}>
				<Grid item sx={{ background: '#F2F2F2', position: 'sticky', top: 0, zIndex: 999 }}>
					<Stack direction='row' justifyContent='space-between' alignItems='center' px={2} py={1}>
						<Typography fontSize='20px' fontWeight={500} color='#212121'>
							{language?.setReminder}
						</Typography>
						<IconButton onClick={onClose}>
							<CloseIcon sx={{ fontSize: '24px', color: '#212121' }} />
						</IconButton>
					</Stack>
				</Grid>

				<Grid item xs minHeight={0} pt={1} sx={{ overflowY: 'auto' }}>
					<Grid item xs={12} sx={{ px: 2 }} display={'flex'} flexDirection={'column'}>
						<Typography py={1} fontSize={'14px'} fontWeight={400} color={'#353535'}>
							{language?.title} *
						</Typography>
						<TextField
							fullWidth
							sx={{
								fontSize : '14px'
							}}
							placeholder={language?.ReminderTitle}
							variant='outlined'
							required
							inputProps={{
								maxLength : 50,

								style : {
									fontSize : 14
								}
							}}
						/>
						<Typography textAlign={'end'} fontSize={12} fontWeight={400} color={'#707070'}>
							0/50
						</Typography>
					</Grid>

					<Grid item xs={12} sx={{ px: 2 }} display={'flex'} flexDirection={'column'}>
						<Typography py={1} fontSize={'14px'} fontWeight={400} color={'#353535'}>
							{language?.description}
						</Typography>
						<TextField
							fullWidth
							placeholder={language?.ReminderDescription}
							variant='outlined'
							multiline
							rows={4}
							inputProps={{
								maxLength : 400,

								style : {
									fontSize : 14 // Set the font size of the input text and placeholder
								}
							}}
						/>
						<Typography textAlign={'end'} fontSize={12} fontWeight={400} color={'#707070'}>
							0/400
						</Typography>
					</Grid>

					{/* Date & Time Input */}
					<Grid item xs={12} sx={{ px: 2 }} display={'flex'} flexDirection={'column'}>
						<Typography py={1} fontSize={'14px'} fontWeight={400} color={'#353535'}>
							{language?.reminderDateTime} *
						</Typography>
						<LocalizationProvider dateAdapter={AdapterDayjs}>
							<DesktopDateTimePicker
								inputFormat='DD MMM YYYY | hh:mm a'
								value={filter.startDate}
								onChange={(date) => handleCustomDateChange(date, 'startDate')}
								maxDate={dayjs(filter.endDate)}
								renderInput={(params) => (
									<TextField
										{...params}
										size='small'
										sx={{
											width                   : '100%',
											'& .MuiInputBase-input' : {
												padding  : '10px',
												fontSize : '14px'
											}
										}}
									/>
								)}
							/>
						</LocalizationProvider>
					</Grid>

					{/* Reminder Type Selector */}
					<Grid item xs={12} p={2} gap={2} display={'flex'} alignItems={'center'} >
						<Typography fontSize={'14px'} fontWeight={400} color={'#353535'}>
							{language?.type}
						</Typography>
						<RadioGroup row value={selectedValue} onChange={handleChange}>
							{labels.map((item) => (
								<FormControlLabel
									key={item.value}
									value={item.value}
									control={<Radio />}
									label={<Typography fontSize={14} color={'#353535'}>{item.label}</Typography>}
								/>
							))}
						</RadioGroup>
					</Grid>

					{selectedValue === 'remindOthers' && (
						<Grid item xs={12} p={2} >
							<Searchlist placeholder='Search' />
						</Grid>
					)}
				</Grid>

				{/* Action Buttons */}
				<Grid item sx={{ background: '#fff', position: 'sticky', bottom: 0, zIndex: 999 }} display={'flex'} justifyContent={'end'} p={1}>
					<Button variant='outlined' onClick={onClose} sx={{ mr: 2, fontSize: '16px', fontWeight: '400', borderRadius: '4px' }}>{language?.cancel}</Button>
					<Button variant='contained' color='primary' sx={{ color: '#fff', boxShadow: 'none', fontSize: '16px', fontWeight: '400', borderRadius: '4px' }}>{language?.add}</Button>
				</Grid>
			</Grid>
		</Drawer>

	);
};

export default SetReminderSlider;
